import { DRPHeader } from "@inputs/date/DateRangePicker/headers";
import { useDRMPHeader } from "./logics";

export const DRMPHeader = () => {
  const props = useDRMPHeader();

  return <DRPHeader {...props} placeholder="mm/aaaa" mask="00/0000" labelStart="De" labelEnd="A" />;
};
